export default {
    SOCKET_STATES : Object.freeze({
        CONNECTED : "CONNECTED"
    })
}